<template>
<div>
  <img v-if="TENANTID==59" class="flowPathPicture" src="../../assets/images/home/59saas.png" alt="">
  <img v-else class="flowPathPicture" src="../../assets/images/home/flowPathPicture.png" alt="">
</div>
</template>
<script>
import { localStorageGetItem } from "@/utils/auth";
export default {
  name: '', 
  mixins: [],
  components: {
  },
  data() {
    return {
      TENANTID:''
    };
  },
  async mounted() {
    console.log('this.TENANTID',this.TENANTID)
    this.TENANTID = localStorageGetItem("TENANT-ID") || "0";
  },
  methods: {
  },
}
</script>
<style lang='scss' scoped>
.flowPathPicture{
  width: 100%;
}
</style>